import { useEffect, useState } from "react"

import { TGroupsDetail } from "@letshang/constants"

import { getGroupDetails } from "@api/firebaseWrappedApis"

export const useGroups = (groupId: string) => {
  const [state, setState] = useState({
    isRestriction: false,
    isLoading: true,
    groupDetails: {} as TGroupsDetail,
  })

  // Fetch Groups
  useEffect(() => {
    fetchGroupDetails()
  }, [groupId])

  const fetchGroupDetails = async () => {
    if (groupId) {
      setState((prev) => ({ ...prev, isLoading: true }))

      getGroupDetails({ groupId })
        .then((res) => {
          setState((prev) => ({
            ...prev,
            isLoading: false,
            groupDetails: res as TGroupsDetail,
          }))
        })
        .finally(() => {
          setState((prev) => ({
            ...prev,
            isLoading: false,
          }))
        })
    }
  }

  return {
    isLoading: state.isLoading,
    groupDetails: state.groupDetails,
  }
}
